import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl } from '@angular/forms';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { Observable, Subscription, debounceTime, map } from 'rxjs';
import { SubSectionData } from 'src/app/model/help';
import { Lang } from 'src/app/model/lang';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectHelpSearchList } from 'src/app/store/help/help.selector';

@Component({
  templateUrl: './helper-guest.dialog.component.html',
})

export class HelperGuestDialogComponent  implements OnInit, OnDestroy {
	currentLang: Lang;
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	helpSearchList$: Observable<SubSectionData[] | undefined>;
	helpSearchListSub: Subscription | undefined;

	helpSearchList: SubSectionData[];

	filterSub: Subscription;
	searchFilter: FormControl = new FormControl('');
	filter: '';

	roleUser: string;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_MX7 = 1700;
	LG_WIDTH = 1500;

	MAX_MD_WIDTH_SHORT = 858;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		){
		this.initSelectors();
	}

	ngOnInit(): void {
		this.filter= '';
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.filter = value;
			this.store.dispatch(HelpActions.getHelpGuestSearch({ filter: this.filter, appid:'frontend'}));
		});
		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.currentLangSub = this.currentLang$?.subscribe((lang) => {
			this.currentLang = lang;
			if (this.filter===''){
				this.store.dispatch(HelpActions.getHelpGuest({appid:'frontend'}));
			} else {
				this.store.dispatch(HelpActions.getHelpGuestSearch({ filter: this.filter, appid:'frontend'}));
			}
		});
		this.helpSearchListSub = this.helpSearchList$.subscribe((helpSearchList) => {
			this.helpSearchList = helpSearchList;
		});
	}

	initSelectors(): void{
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.helpSearchList$ = this.store.select(selectHelpSearchList);
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
		this.helpSearchListSub?.unsubscribe();
	}


	accordionAction(): void {
		const listaFrames = document.getElementsByTagName('iframe');

		for (let index = 0; index <= listaFrames.length; index++) {
			if (listaFrames[index]!== undefined){
					const iframe = listaFrames[index].contentWindow;
					iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}
	}

	closeDialog(): void{
		this.ref.close();
	}


	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return (this.screenWidth <= this.MIN_MD_WIDTH);
	}

	onTablet(): boolean {
		return (this.screenWidth >= this.MIN_MD_WIDTH) && (this.screenWidth <= this.MAX_MD_WIDTH_SHORT);
	}

	dynamicFullButton(buttonType: string, classType: string): string {
		if (buttonType === 'add') {
			if (this.screenWidth <= this.MAX_MD_WIDTH_SHORT) {
				return "col-12 flex justify-content-center"
			} else {
				return "col-6 flex justify-content-start";
			}
		} else { // search
			if (this.onMobile()) {
				switch (classType) {
					case 'mainCol':
						return "col-12"
					case 'borderRow':
						return "row";
					case 'borderInput':
						return "col-12 w-full p-0";
					case 'label':
						return "col-12 p-1";
					default:
						return "";
				}
			}
			if (this.onTablet()) {
				switch (classType) {
					case 'mainCol':
						return "col-12"
					case 'borderRow':
						return "";
					case 'borderInput':
						return "";
					case 'label':
						return "";
					default:
						return "";
				}
			}
			if (this.screenWidth <= this.LG_WIDTH) {
				switch (classType) {
					case 'mainCol':
						return "col-6"
					case 'borderRow':
						return "";
					case 'borderInput':
						return "";
					case 'label':
						return "";
					default:
						return "";
				}
			} else { // fullDesktop
				switch (classType) {
					case 'mainCol':
						return "col-6"
					case 'borderRow':
						return "";
					case 'borderInput':
						return "";
					case 'label':
						return "";
					default:
						return "";
				}
			}
		}
	}

	dynamicInputTextWidth(): string {
		return (this.onMobile()) ? "w-full h-2_5rem" : "w-25rem h-2rem";
	}

	dynamicButtonWidth() : string {
	return (this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH) ? "w-full" : "w-16rem";
	}
}
